/**
 * @license lucide v0.356.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const BookKey = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H14" }],
    ["path", { d: "M20 8v14H6.5a2.5 2.5 0 0 1 0-5H20" }],
    ["circle", { cx: "14", cy: "8", r: "2" }],
    ["path", { d: "m20 2-4.5 4.5" }],
    ["path", { d: "m19 3 1 1" }]
  ]
];

export { BookKey as default };
//# sourceMappingURL=book-key.js.map
